import { createStore } from "vuex";
// eslint-disable-next-line import/no-cycle
import { authentication } from "@/store/common/authentication";
import { createCreatives } from "@/store/creativesUpload/createCreatives";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},

  modules: {
    authentication,
    createCreatives
  }
});
